import { GridBlockDimensions } from '@client/components/mylounge/campaigns/grid/constants';

export const IMAGES_WIDTH = {
    MOBILE: 360,
    DESKTOP_BANNER: 1920,
};

export const GridBlockDimensionsToWidth = {
    [GridBlockDimensions.SQUARE_SMALL]: 240,
    [GridBlockDimensions.RECTANGLE_VERTICAL]: 280,
    [GridBlockDimensions.RECTANGLE_HORIZONTAL]: 600,
    [GridBlockDimensions.SQUARE_BIG]: 600,
};
